import { Card, Checkbox, makeStyles, Stack } from '@gogame/components';

import { useHover } from '@gogame/hooks-ts';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles(
  (theme) => {
    return {
      root: {
        // '&:hover': {
        //   boxShadow: ({ withHover }) =>
        //     withHover ? `${theme.shadows[5]}` : null,
        // },
      },
      hovered: {
        boxShadow: theme.shadows[5],
      },
      selected: {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.action.selected,
      },
      controls: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1,
        color: theme.palette.common.white,
        pointerEvents: 'none',
      },
      checkbox: {
        color: theme.palette.common.white,
        pointerEvents: 'all',
      },
      actions: {
        pointerEvents: 'all',
      },
    };
  },
  { name: 'GgTile' }
);

const Tile = ({ children, actions, selectable, selected, onSelect }) => {
  const [ref, hovered] = useHover();
  const classes = useStyles();

  return (
    <Card
      ref={ref}
      elevation={6}
      className={clsx(classes.root, {
        [classes.selected]: selected,
        [classes.hovered]: selectable && hovered,
      })}
    >
      {selectable && (hovered || selected) ? (
        <Stack
          className={classes.controls}
          justifyContent={'space-between'}
          direction={'row'}
          spacing={1}
        >
          <Checkbox
            className={classes.checkbox}
            checked={selected}
            onClick={onSelect}
          />
          <div className={classes.actions}>{actions}</div>
        </Stack>
      ) : null}
      {children}
    </Card>
  );
};

export default Tile;
